import {
    ReferenceInput,
    required,
    SimpleForm,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaEditView } from "../components/views/RaEditView";
import { RaDateInput } from "../components/inputs/Ra/RaDateInput";
import { RaTextInput } from "../components/inputs/Ra/RaTextInput";
import { RaAutocompleteInput } from "../components/inputs/Ra/RaAutocompleteInput";
import { RaSelectInput } from "shared/src/components/inputs/Ra/RaSelectInput";

export const DamageReportEdit = (props) => {
    const translate = useTranslate();
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaEditView
            {...props}
            mutationMode="pessimistic"
            actions={<ToolbarWithHistory back={true} show={true} />}
            redirect="show"
        >
            <SimpleForm>
                <RaTextInput source="title" validate={[required()]} />
                <RaDateInput source="date" validate={[required()]} defaultValue={new Date()} />
                <RaTextInput source="damageDescription" multiline rows={3} />
                <RaTextInput source="incidentDescription" multiline rows={3} />
                <RaTextInput source="remarks" multiline rows={3} />
                <ReferenceInput
                    source="sku.id"
                    reference="skus"
                    enableGetChoices={({ labelNumber }) =>
                        !!(labelNumber && labelNumber.length >= 0)
                    }
                >
                    <RaAutocompleteInput
                        filterToQuery={(input) => {
                            return { labelNumber: input };
                        }}
                        label={"equip.sku"}
                        field="labelNumber"
                        validate={[required()]}
                        loadingText={""}
                    />
                </ReferenceInput>
                <ReferenceInput
                    source="rental.id"
                    reference="rentals"
                    enableGetChoices={({ search }) => !!(search && search.length >= 0)}
                >
                    <RaAutocompleteInput
                        filterToQuery={(input) => {
                            return { search: input };
                        }}
                        label="equip.rental"
                        field="name"
                        loadingText={""}
                    />
                </ReferenceInput>
                <ReferenceInput
                    source="responsibleUser.id"
                    reference="users"
                    enableGetChoices={({ userIdentifier }) =>
                        !!(userIdentifier && userIdentifier.length >= 0)
                    }
                >
                    <RaAutocompleteInput
                        filterToQuery={(input) => {
                            return { userIdentifier: input };
                        }}
                        label="equip.responsibleUser"
                        field="fullName"
                        optionText={({ fullName, userIdentifier }) => {
                            return `${fullName} (${userIdentifier})`;
                        }}
                        loadingText={""}
                    />
                </ReferenceInput>
                <RaSelectInput
                    label="equip.status"
                    source="status"
                    validate={[required()]}
                    choices={[
                        { id: "new", name: translate("equip.damageReportStatus_new") },
                        {
                            id: "in_progress",
                            name: translate("equip.damageReportStatus_in_progress"),
                        },
                        { id: "completed", name: translate("equip.damageReportStatus_completed") },
                    ]}
                />
            </SimpleForm>
        </RaEditView>
    );
};
